$(function(){//ページ読み込み後に動かすjQuery
  
  // ページ内リンクをスクロールに 
  $('a[href^="#"]').click(function(){
    const headerH = $('.l-header').outerHeight();
    const href= $(this).attr("href");
    const target = $(href == "#" || href == "" ? 'html' : href);
    const position = target.offset().top - headerH;//固定ヘッダーの分だけずらす
    $("html, body").animate({scrollTop:position}, 800, "swing");
    return false;
  });
 
  // アコーディオン汎用
  function accToggle(trigger,target,closeAll = false) {
    // triggerには要素
    // targetにはクラス名を入れる
    // closeAll trueにすると、他の同様のアコーディオンを閉じた上で開く
    if(trigger.siblings(target).attr('aria-hidden') == 'false') {
      trigger.siblings(target).attr('aria-hidden','true');
    } else {
      if(closeAll) {
        $(target+'[aria-hidden=false]').attr('aria-hidden','true');
      }
      trigger.siblings(target).attr('aria-hidden','false');
    }
  }
 
// ヘッダーの実際の下端位置を計算（告知バーの高さも自動で反映される）
function updateHeaderOffset() {
  const header = document.querySelector('.l-header');
  if (!header) return;
  const offset = header.getBoundingClientRect().bottom;
  document.documentElement.style.setProperty('--header-offset', `${offset}px`);
}

// 初回・リサイズ時に更新
$(window).on('load resize', updateHeaderOffset);
updateHeaderOffset();

// ハンバーガー開閉
$('.l-header-hamburger__btn').click(function(){
  let trigger = $(this);
  let target = '.l-header-hamburger-wrapper';
  updateHeaderOffset(); // 開く直前に必ず最新位置を反映
  $(this).toggleClass('open');
  accToggle(trigger,target);
});
  
  // ハンバーガー内のアコーディオン開閉
  $('.l-header-hamburger-nav-acc__trigger').click(function(){
    let trigger = $(this);
    let target = '.l-header-hamburger-nav-acc-wrapper';
    $(this).toggleClass('open');
    accToggle(trigger,target);
  });
  
  // フッターメニュー内のアコーディオン開閉
  $('.l-footer-main-nav-acc__trigger').click(function(){
    let trigger = $(this);
    let target = '.l-footer-main-nav-acc-wrapper';
    $(this).toggleClass('open');
    accToggle(trigger,target);
  });
  
  // 商品ページのアコーディオン開閉
  $('.c-product-single-sub-acc__trigger').click(function(){
    let trigger = $(this);
    let target = '.c-product-single-sub-acc-wrapper';
    $(this).toggleClass('open');
    accToggle(trigger,target);
  });
  
  // ページトップに戻るボタン
  const pageTopBtnPC = () => {
    let showFlag = false;
    const topBtn = $('.c-footer-fix-pc__top');    
    topBtn.css('bottom', '-100px');
    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        if (showFlag == false) {
          showFlag = true;
          topBtn.stop().animate({'bottom' : '0'}, 200); 
        }
      } else {
        if (showFlag) {
          showFlag = false;
          topBtn.stop().animate({'bottom' : '-100px'}, 200); 
        }
      }
    });
  }
  pageTopBtnPC();
  
  // スマホのみ画像スライダー
  $('.js-sp-slider__prev').click(function(){ 
    let scrollBox = $(this).closest('section').find('.js-sp-slider');
    console.log(scrollBox)
    let scrollAmount = $(window).width();
    scrollBox.each(function() {
      $(this).animate({ scrollLeft: `-=${scrollAmount}` }, 500);
    })
  })
  $('.js-sp-slider__next').click(function(){ 
    let scrollBox = $(this).closest('section').find('.js-sp-slider');
    let scrollAmount = $(window).width();
    scrollBox.each(function() {
      $(this).animate({ scrollLeft: `+=${scrollAmount}` }, 500);
    })
  })
 
  // swiper(スライダー)
  // 商品ページサムネイル画像
  const productSliderThumbEl = document.querySelector('.js-product-single-main-slider-thumbnail');
  const productSliderMainEl = document.querySelector('.js-product-single-main-slider');

  let productSliderThumb = null;
  let productSliderMain = null;

  if (productSliderThumbEl && productSliderMainEl) {
    productSliderThumb = new Swiper('.js-product-single-main-slider-thumbnail', {//swiperを適用するclassを指定
      //以下設定
      slidesPerView: 3.5,
      spaceBetween: 10,
      slideToClickedSlide: true,
      watchSlidesProgress: true,
      breakpoints: {
        1024: {
          slidesPerView: 5,
          direction: 'vertical',
          spaceBetween: 15
        }
      }
    });

    // 商品ページメイン画像
    productSliderMain = new Swiper('.js-product-single-main-slider', {//swiperを適用するclassを指定
      //以下設定
      slidesPerView: 1,
      loop: true,
      speed: 250,
      navigation: {
        nextEl: ".c-product-single-main-slider__next",
        prevEl: ".c-product-single-main-slider__prev",
      },
      thumbs: {
        swiper: productSliderThumb,
      }
    });

    // =========================
    // variant / slider 双方向同期
    // =========================
    const productRoot = document.querySelector('.c-product-single-main[data-section]');
    const sectionId = productRoot ? productRoot.dataset.section : null;
    const variantsJsonEl = sectionId
      ? document.getElementById(`ProductVariants-${sectionId}`)
      : null;

    let variants = [];
    if (variantsJsonEl) {
      try {
        variants = JSON.parse(variantsJsonEl.textContent);
      } catch (e) {
        console.warn('Product variants JSON parse error', e);
      }
    }

    let isSyncingFromVariant = false;
    let isSyncingFromSlider = false;

    function getVariantSelectsEl() {
      if (!sectionId) return null;
      return document.querySelector(`variant-selects[data-section="${sectionId}"]`);
    }

    function getSelectedOptions() {
      const root = getVariantSelectsEl();
      if (!root) return [];

      const fieldsets = Array.from(root.querySelectorAll('fieldset'));
      if (fieldsets.length) {
        return fieldsets.map((fieldset) => {
          const checked = fieldset.querySelector('input:checked');
          return checked ? checked.value : '';
        });
      }

      const selects = Array.from(root.querySelectorAll('select'));
      return selects.map((select) => select.value);
    }

    function findVariantByOptions(selectedOptions) {
      if (!variants.length) return null;

      return variants.find((variant) => {
        if (!variant.options || variant.options.length !== selectedOptions.length) return false;
        return variant.options.every((value, index) => value === selectedOptions[index]);
      }) || null;
    }

    function findBestVariantByMediaId(mediaId) {
      if (!variants.length) return null;

      const currentOptions = getSelectedOptions();

      const candidates = variants.filter((variant) => {
        return String(variant?.featured_media?.id || '') === String(mediaId);
      });

      if (!candidates.length) return null;

      // 現在の他オプションをできるだけ維持する variant を優先
      candidates.sort((a, b) => {
        const scoreA = (a.options || []).reduce((score, value, index) => {
          return score + (value === currentOptions[index] ? 1 : 0);
        }, 0);

        const scoreB = (b.options || []).reduce((score, value, index) => {
          return score + (value === currentOptions[index] ? 1 : 0);
        }, 0);

        return scoreB - scoreA;
      });

      return candidates[0];
    }

    function syncVariantLabelUI() {
      const root = getVariantSelectsEl();
      if (!root) return;

      root.querySelectorAll('.c-product-single-main-info-variant-group').forEach((group) => {
        const checked = group.querySelector('input:checked');
        const textWrapper = group.querySelector('.c-product-single-main-info-variant-group__selected');

        group
          .querySelectorAll('label.c-product-single-main-info-variant-group-inputs__item')
          .forEach((label) => {
            const inputId = label.getAttribute('for');
            label.classList.toggle('active', !!(checked && checked.id === inputId));
          });

        if (checked && textWrapper) {
          textWrapper.textContent = checked.value;
        }
      });
    }

    function slideToMediaId(mediaId, speed = 250) {
      if (!mediaId || !productSliderMain) return;

      const slides = Array.from(
        document.querySelectorAll('.js-product-single-main-slider .swiper-slide:not(.swiper-slide-duplicate)')
      );

      // loop: true の Swiper 11 はループのためにスライドの DOM 順を並べ替える。
      // DOM 上の位置ではなく元の並び順（data-swiper-slide-index＝realIndex と同じ基準）を使う。
      // DOM 位置を使うと、最後→最初へ回り込んだ直後に誤った番号へ遷移を割り込ませ、
      // Swiper が遷移中のまま固まって前後ボタンが効かなくなっていた
      const targetSlide = slides.find((slide) => {
        return String(slide.dataset.mediaId) === String(mediaId);
      });

      if (!targetSlide) return;
      const targetIndex = Number(targetSlide.dataset.swiperSlideIndex);
      if (productSliderMain.realIndex === targetIndex) return;

      isSyncingFromVariant = true;
      productSliderMain.slideToLoop(targetIndex, speed);

      setTimeout(() => {
        isSyncingFromVariant = false;
      }, speed + 50);
    }

    function applyVariantToInputs(variant) {
      const root = getVariantSelectsEl();
      if (!root || !variant) return;

      const fieldsets = Array.from(root.querySelectorAll('fieldset'));
      const selects = Array.from(root.querySelectorAll('select'));
      const changedControls = [];

      if (fieldsets.length) {
        fieldsets.forEach((fieldset, index) => {
          const targetValue = variant.options[index];
          const targetInput = Array.from(fieldset.querySelectorAll('input')).find((input) => {
            return input.value === targetValue;
          });

          if (targetInput && !targetInput.checked) {
            targetInput.checked = true;
            changedControls.push(targetInput);
          }
        });
      } else if (selects.length) {
        selects.forEach((select, index) => {
          const targetValue = variant.options[index];
          if (typeof targetValue !== 'undefined' && select.value !== targetValue) {
            select.value = targetValue;
            changedControls.push(select);
          }
        });
      }

      syncVariantLabelUI();

      // Dawn の change を最後の1回だけ発火
      const lastChanged = changedControls[changedControls.length - 1];
      if (lastChanged) {
        lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // 初期UI同期
    syncVariantLabelUI();

    // スウォッチ / セレクト変更 → 即座に画像切替
    if (sectionId) {
      $(document).on(
        'change',
        `variant-selects[data-section="${sectionId}"] input, variant-selects[data-section="${sectionId}"] select`,
        function () {
          syncVariantLabelUI();

          const selectedVariant = findVariantByOptions(getSelectedOptions());
          if (selectedVariant && selectedVariant.featured_media && selectedVariant.featured_media.id) {
            slideToMediaId(selectedVariant.featured_media.id, 250);
          }
        }
      );
    }

    // Dawn 側の variantChange 後にも最終同期
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        const variant = event && event.data ? event.data.variant : null;
        if (!variant) return;

        syncVariantLabelUI();

        if (variant.featured_media && variant.featured_media.id) {
          slideToMediaId(variant.featured_media.id, 250);
        }
      });
    }

    // スライダー / サムネイル操作 → スウォッチ変更
    productSliderMain.on('slideChange', function () {
      if (isSyncingFromVariant || isSyncingFromSlider) return;

      const activeSlide = this.slides[this.activeIndex];
      const mediaId = activeSlide && activeSlide.dataset ? activeSlide.dataset.mediaId : null;
      if (!mediaId) return;

      const targetVariant = findBestVariantByMediaId(mediaId);
      if (!targetVariant) return;

      const currentVariant = findVariantByOptions(getSelectedOptions());
      if (currentVariant && currentVariant.id === targetVariant.id) return;

      isSyncingFromSlider = true;
      applyVariantToInputs(targetVariant);

      setTimeout(() => {
        isSyncingFromSlider = false;
      }, 0);
    });
  }
 
  // 商品リストスライダー
  const productListSlider = new Swiper('.js-product-list-slider', {//swiperを適用するclassを指定
    //以下設定
    slidesPerView: 1.4,
    spaceBetween: 30,
    speed: 500,
    navigation: {
      nextEl: ".c-product-list-slider__next",
      prevEl: ".c-product-list-slider__prev",
    },
    breakpoints: {
      744: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      }
    }
  });

  // POPUPニュースリストスライダー
  const popupListSlider = new Swiper('.js-popup-slider', {//swiperを適用するclassを指定
    //以下設定
    slidesPerView: 1.4,
    spaceBetween: 30,
    speed: 500,
    navigation: {
      nextEl: ".c-popup-slider__next",
      prevEl: ".c-popup-slider__prev",
    },
    breakpoints: {
      744: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      }
    }
  });
});
 
//下からふわっと表示
const fadeInUp = () => {
  const targets = document.querySelectorAll('.u-fadeinUp');
  let windowHeight = $(window).height();
  $(window).resize(function() {
    windowHeight = $(window).height();
  });
  Object.values(targets).forEach(target => {
    const targetPos = target.getBoundingClientRect().top;
    $(window).scroll(function () {
      let scrollY = $(this).scrollTop();    
      if(scrollY > targetPos - windowHeight) {
        target.classList.add('u-fadeinUp-active');
      }
    })
  })
}
fadeInUp();
